import { request } from './api.js';

export interface DataKind {
  data_kind_id: string;
  label_de: string | null;
  label_en: string | null;
  sort_order: number;
}

export interface DataKindCreateBody {
  label_de: string | null;
  label_en: string | null;
  sort_order?: number;
}

export type DataKindUpdateBody = Partial<DataKindCreateBody>;

// Gemeinsamer Helfer für Task 8/8b (Testdaten-Tab + Ausführungs-Panel): beide zeigen dieselbe
// Datenart als Text an und sollen dabei nicht getrennt voneinander die Sprach-Fallback-Regel
// implementieren. Nie einen leeren String liefern — sonst zeigt die UI eine leere Zelle/Option,
// die wie ein Rendering-Fehler aussieht statt wie eine unbenannte Datenart.
export function kindLabel(
  kind: { label_de: string | null; label_en: string | null },
  lang: string,
): string {
  const de = kind.label_de?.trim() || '';
  const en = kind.label_en?.trim() || '';
  const preferred = lang === 'en' ? en : de;
  const fallback = lang === 'en' ? de : en;
  return preferred || fallback || '—';
}

const base = (p: string) => `/v1/projects/${p}/catalog/data-kinds`;

export const dataKindsApi = {
  list: (p: string) => request<DataKind[]>(base(p)),
  create: (p: string, body: DataKindCreateBody) =>
    request<DataKind>(base(p), { method: 'POST', body: JSON.stringify(body) }),
  update: (p: string, id: string, body: DataKindUpdateBody) =>
    request<DataKind>(`${base(p)}/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  merge: (p: string, id: string, targetId: string) =>
    request<{ ok: true; moved: number }>(`${base(p)}/${id}/merge`, {
      method: 'POST',
      body: JSON.stringify({ target_id: targetId }),
    }),
  remove: (p: string, id: string) => request<void>(`${base(p)}/${id}`, { method: 'DELETE' }),
};
